// extracted by mini-css-extract-plugin
export default {"pageWrapper":"stripePlansPage_pageWrapper__-gk4z"};